// Rekit uses a new approach to organizing actions and reducers. That is
// putting related actions and reducers in one file. See more at:
// https://medium.com/@nate_wang/a-new-approach-for-managing-redux-actions-91c26ce8b5da

import {
  PRODUCT_SET_QUANTITY,
} from './constants';

export function setQuantity(message) {
  return {
    type: PRODUCT_SET_QUANTITY,
    data:message
  };
}

export function reducer(state, action) {
  switch (action.type) {
    case PRODUCT_SET_QUANTITY:
      return {
        ...state,
        quantity:action.data
      };

    default:
      return state;
  }
}



// WEBPACK FOOTER //
// ./src/features/product/redux/setQuantity.js